import { takeEvery } from 'redux-saga/effects';
import { GlobalAction, GlobalActions, HTTP_METHOD } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { PrometheusCounterIncreasePayload, PrometheusCounterRequestModel } from '@ps20/bff-models';
import { put } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
// NOSONAR

const url = '/privatschutz/api/prometheuscounter';

export enum INCREASE_PROMETHEUS_COUNTER_EVENTS {
  SUCCESS = 'INCREASE_PROMETHEUS_REQUEST_SUCCESS',
  FAILED = 'INCREASE_PROMETHEUS_REQUEST_FAIL',
}

export function* prometheusCounterSaga() {
  yield takeEvery(GlobalActions.INCREASE_PROMETHEUS_COUNTER, safeSaga(increaseCounter, App.SHOP));
}

export function* increaseCounter(action: GlobalAction<Array<PrometheusCounterIncreasePayload>>) {
  const payload: PrometheusCounterRequestModel = { counters: action.payload };
  yield put(
    new GlobalActions().doRequest({
      appId: App.SHOP,
      body: payload,
      url,
      successEvent: INCREASE_PROMETHEUS_COUNTER_EVENTS.SUCCESS,
      errorEvent: INCREASE_PROMETHEUS_COUNTER_EVENTS.FAILED,
      method: HTTP_METHOD.POST,
    }),
  );
}
